import { BasicSelect, MultiSelect } from 'vue-search-select'
import CryptoJS from 'crypto-js'
import Pagination from './../../../../shared/components/pagination'
import Loader from '../../../../shared/components/loader'
import CONSTANT from '../../../../shared/constants/constant'
import Util from '../../../../shared/util/util'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueMaterial from 'vue-material';
import TripServices from '../../../services/firstAndLastmilemanagement.service'
import ClientService from '../../../../clientmanagement/services/clientmanagement.service';
import {Validator} from 'vee-validate';
import Multiselect from 'vue-multiselect'
const moment = require('moment')

export default {
  name: 'CreateBoxTypeconfig',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    Loader,
    Multiselect
  },
  props: ['parentObj'],
  data: function () {
    return {
      isLoading: false,
      companyNamelist: [],
      selectedBoxType: { value: "", text: "" },
      selectedboxType: {},
      selectedBoxTypeTree: null,
      boxtypelist: [],
      Action: "",
      useremail: "",
      selectedClient:null,
      selectedclient: {},
      boxtypeerror: false,
      boxtypeErr:'',
      clientErr:'',
      Clientlist:[],
      disbaleClientName: false,
      savedisableflag : true
    };
  },
  created() {
    this.$root.$refs.boxtypeconfig = this;
  },
  computed: {},
  async mounted () {
    this.boxtypelist = this.parentObj.boxtypelist;
    this.Clientlist = this.parentObj.clientlist;
    this.useremail = this.parentObj.useremail;
    if (this.parentObj.action == 'update') {
      this.isLoading = true
      this.selectedBoxType.value = this.parentObj.data.boxtypeid;
      this.selectedBoxType.text = this.parentObj.data['boxtypemaster.boxtype'];
      this.selectedClient = {
        value : this.parentObj.data.clientid,
        text : this.parentObj.data.clientname,
        id :this.parentObj.data.clientbusinessaccountid
      }
      this.savedisableflag = false
      this.isLoading = false;
      this.disbaleClientName= true;
    }
  },
  methods: {
    selectBoxType(data){
      this.selectedBoxType = data;
      this.savedisableflag = false;
    },
    selectClient(data){
      this.selectedClient = data;
      this.savedisableflag = false;
    },

    async create() {
      try {
        this.isLoading = true;
        if (this.checkErr()) {
          this.isLoading = false;
          return false;
        }
        let boxlist = []
        if (this.parentObj.action == 'update') {
          boxlist.push(this.selectedBoxType.value);
        } else {
          boxlist = this.selectedBoxTypeTree.map(el => el.id)
        }
        let input = {
          clientid: this.selectedClient.value,
          clientname: this.selectedClient.text,
          boxtypeid: this.parentObj.action == 'update' ? this.selectedBoxType.value : "",
          boxtypename: this.parentObj.action == 'update' ? this.selectedBoxType.text : "",
          boxtypelist: boxlist,
          clientbusinessaccountid: this.selectedClient.id,
          lastmodifiedby: this.useremail,
          action: this.parentObj.action
        }
        if (this.parentObj.action == 'update') {
          input.configid = this.parentObj.data.id
        }
        let result = await ClientService.saveClientBoxTypeMapping(input);
        if (result.data.code == 200) {
          let message = this.parentObj.action == 'update' ? "Updated Successfully" : "Created Successfully";
          this.$alert(message, "", "success");
          this.showBoxTypeConfigurationList();
        } else if (result.data.code == 409) {
          let boxname = []
          if (this.parentObj.action == 'update') {
            boxname.push(this.selectedBoxType.text)
          } else {
            this.selectedBoxTypeTree.map(el => {
              result.data.data.forEach(element => {
                if (element == el.id) {
                  boxname.push(el.label)
                }
              });
            })
          }
          this.$alert(`${result.data.message} ${boxname.join(', ')}`, "", "error");
        } else {
          this.$alert(result.data.message, "", "error");
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error)
      }
    },
    showBoxTypeConfigurationList() {
      this.$emit("goBackToParent")
    },
    checkErr(){
      let err = 0
      if (this.parentObj.action == 'update') {
        if (this.selectedBoxType.value == "") {
          this.boxtypeErr = 'Please Select Box Type.'
          err = 1;
          this.savedisableflag = true;
        } else {
          this.boxtypeErr = ''
        }
      } else {
        if (this.selectedBoxTypeTree == null || this.selectedBoxTypeTree.length == 0) {
          this.boxtypeErr = 'Please Select Box Type.'
          err = 1;
          this.savedisableflag = true;
        } else {
          this.boxtypeErr = ''
          this.savedisableflag = false;
        }
      }
      if (!this.selectedClient) {
        this.clientErr = 'Please Select Client Name'
        err = 1;
        this.savedisableflag = true;
      } else {
        this.clientErr ='';
      }
      return err
    },   
    checkhubmappingerr(){
      let err = 0
      if(this.selectedBoxType.value ==""){
        this.boxtypeErr = 'Please Select Box Type.'
        err = 1
      }else{
        this.boxtypeErr = ''
      }
      return err
    },   

  },
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/boxtypeconfig/CreateBoxTypeconfig/CreateBoxTypeconfig.component.js